import { Seo, Breadcrumbs, breadcrumbSchema, faqSchema } from "@/components/Seo";
import { Reveal, SectionTag } from "@/components/Motion";
import { ChatButton, FinalCta } from "@/components/Cta";
import FaqAccordion from "@/components/FaqAccordion";
import { FAQS } from "@/data/site";

const CRUMBS = [{ name: "首页", path: "/" }, { name: "常见问题", path: "/faq" }];

export default function Faq() {
  return (
    <>
      <Seo
        title="常见问题 — TikTok Shop 马来西亚问题解答 | TKShopMY"
        description="关于 TikTok Shop 马来西亚的常见问题解答：开店流程、所需资料、费用、代运营服务、内容规划，以及 TKShopMY 是否与 TikTok 官方有关。"
        path="/faq"
        schemas={[breadcrumbSchema(CRUMBS), faqSchema(FAQS)]}
      />
      <section className="pt-28 md:pt-40 pb-14 md:pb-20" data-testid="faq-hero">
        <div className="mx-auto max-w-4xl px-5 md:px-8">
          <Breadcrumbs items={CRUMBS} />
          <Reveal>
            <SectionTag>常见问题</SectionTag>
            <h1 className="font-display text-4xl font-medium leading-[1.15] text-balance sm:text-5xl">
              关于 TikTok Shop 马来西亚的坦白回答
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-ink/65 md:text-lg">
              马来西亚卖家最常问的问题都在这里 —— 开店、资料、费用、代运营，
              以及我们能承诺什么、不能承诺什么。找不到你的问题？
              <span className="font-medium text-ink">直接 WhatsApp 问我们</span>，顾问就在那里。
            </p>
          </Reveal>
        </div>
      </section>

      <section className="pb-16 md:pb-24">
        <div className="mx-auto max-w-4xl px-5 md:px-8">
          <Reveal>
            <FaqAccordion faqs={FAQS} testIdPrefix="faq-page" />
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 rounded-2xl bg-forest p-8 text-paper md:flex md:items-center md:justify-between">
              <div>
                <h2 className="font-display text-2xl font-semibold">还有问题想问？</h2>
                <p className="mt-2 text-sm text-paper/70">直接问 —— 不用填表格，不用注册。先问清楚再决定。</p>
              </div>
              <div className="mt-5 md:mt-0">
                <ChatButton location="faq-page" variant="lime" testId="faq-page-chat-button">
                  WhatsApp 咨询
                </ChatButton>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <FinalCta />
    </>
  );
}
